module.exports = __webpack_public_path__ + "img/menu.04826e6b.svg";